export const OBSERVER_OPTIONS = {
  ALL: false,
  ACTIVE_ONLY: true
};
